import Swiper from "swiper/bundle";

export default class Carousel {
	constructor(element) {
		this.element = element;
		this.options = {
			slidesPerView: 1,
			spaceBetween: 40,

			direction: "horizontal",
			pagination: {
				el: this.element.querySelector(".swiper-pagination"),
				clickable: 'true',
			},
			navigation: {
				nextEl: this.element
					.closest(".wrapper")
					.querySelector(".swiper-button-next"),
				prevEl: this.element
					.closest(".wrapper")
					.querySelector(".swiper-button-prev"),
			},
		};
		this.toggleButtons = element.querySelectorAll(".swiper-slide-content");

		this.setOptions();
		this.init();
	}

	setOptions() {
		// split
		if ("split" in this.element.dataset) {
			this.options.breakpoints = {
				1388: {
					slidesPerView: 4,
				},
				1024: {
					slidesPerView: 3.2,
				},

				768: {
					slidesPerView: 3,
				},
				480: {
					slidesPerView: 2.2,
				},
				375: {
					slidesPerView: 1,
				},
			};
		}

		// autoplay
		if ("autoplay" in this.element.dataset) {
			this.options.autoplay = {
				delay: 3000,
				pauseOnMouseEnter: true,
				disableOnInteraction: false,
			};
		}

		// loop
		if ("loop" in this.element.dataset) {
			this.options.loop = true;
		}

		// slides
		if ("slides" in this.element.dataset) {
			this.options.slidesPerView =
				parseFloat(this.element.dataset.slides, 10) ||
				this.options.slidesPerView;
		}

		// vertical
		if ("vertical" in this.element.dataset) {
			this.options.direction = "vertical";
		}

		if ("fixed" in this.element.dataset) {
			const heights = [];
			this.element.querySelectorAll(".inner__swiper").forEach((slide) => {
				heights.push(slide.offsetHeight);
				const contentHeight =
					slide.querySelector(".content__carousel").offsetHeight;
				// 895 = max height of the slide, 96 = padding + gap
				slide.querySelector("img").style.minHeight =
					895 - contentHeight - 96 - 96 + "px";
			});
			this.element.querySelectorAll(".inner__swiper").forEach((slide) => {
				slide.style.height = Math.max(...heights) + "px";
			});
			this.element.parentNode.style.height = Math.max(...heights) + "px";
		}
	}

	init() {
		this.setOptions();
		new Swiper(this.element, this.options);

		this.toggleButtons.forEach((btn) => {
			btn.addEventListener("click", () => {
				const slide = btn.closest(".swiper-slide");
				const isActive = slide.classList.contains("active");

				this.element.querySelectorAll(".swiper-slide.active").forEach((s) => {
					s.classList.remove("active");
				});

				if (!isActive) {
					slide.classList.add("active");
				}
			});
		});
	}
}
